export default __webpack_public_path__ + "static/medicatec-cec59dd53130937ac69a37a1ca066065.png";